import React, { useState } from 'react';
import { Image, message, Popover } from 'antd';
import urlImg from '../../../img/medium.png';
import style from './intermediateStand.module.scss';

const IntermediateStand = ({setImages, images, colorStand}) => {
  const { 
    logoContainer,
    upBannerContainer,
    centerContainer,
    upRightContainer,
    lowerRightContainer,
    fixedLeftContainer,
    imgStand
  } = style;

  const [imageName, setImageName] = useState([]);

  const handleChange = (e, max) => {
    if(images[e.target.name]?.length > max - 1) {
      message.error('No puedes cargar más imagenes en este lugar');
      return;
    }
    Array.from(e.target.files).forEach(img => {
      const reader = new FileReader();
      reader.readAsDataURL(img);
      reader.onloadend = () => {
        setImages({
          ...images,
          [e.target.name]: images[e.target.name] ? [...images[e.target.name], reader.result] : [reader.result]
        });
      };

      setImageName({
        ...imageName,
        [e.target.name]: imageName[e.target.name] ? [...imageName[e.target.name], img.name] : [img.name]
      });
    });
  };

  const content = bannerName => {
    return(
      <div>
        <p style={{color: '#F57255'}}>** Al editar un banner se sobreescribirán las imágenes previamente cargadas. <br/>Deberá subirlas nuevamente. **</p>
        {imageName[bannerName]?.map((img, i) => {
          return(
            <div key={i}>
              <span style={{color: '#0F1F5D'}}>
                {i+1}. {img}
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  const countFiles = (nameBanner, max) => {
    const count = imageName[nameBanner]?.length;
    if(count === undefined) return (<div>Espacios disponibles: {max}</div>);
    else return (<div>Espacios disponibles: {max - count}</div>);
  };
  
  return(
    <div>
      <Image preview={false}
        src={urlImg}
        alt="medium stand"
        className={imgStand}
        style={{background: `${colorStand}`}}
      />
      <div className={logoContainer}>
        <span>Logo <br/> (262 x 262)</span>
        <Popover
          title={countFiles('logos', 1)}
          content={content('logos')}
        >
          <label htmlFor='inpLogo'>Examinar...</label>
        </Popover>
        <input
          id='inpLogo'
          type='file'
          name='logos'
          onChange={e => handleChange(e, 1)}
        />
      </div>
      <div className={upBannerContainer}>
        <span>Banner superior <br/> (526 x 262)</span>
        <Popover
          title={countFiles('upperBanner', 3)}
          content={content('upperBanner')}
        >
          <label htmlFor='inpUpBanner'>Examinar...</label>
        </Popover>
        <input
          id='inpUpBanner'
          type='file'
          name='upperBanner'
          onChange={e => handleChange(e, 3)}
        />
      </div>
      <div className={centerContainer}>
        <span>Banner central <br/> (452 x 254)</span>
        <Popover
          title={countFiles('center', 3)}
          content={content('center')}
        >
          <label htmlFor='inpCenter'>Examinar...</label>
        </Popover>
        <input
          id='inpCenter'
          type='file'
          name='center'
          onChange={e => handleChange(e, 3)}
        />
      </div>
      <div className={upRightContainer}>
        <span>Banner lateral derecho <br/> (236 x 514)</span>
        <Popover
          title={countFiles('upperRightBanner', 6)}
          content={content('upperRightBanner')}
        >
          <label htmlFor='inpUpRight'>Examinar...</label>
        </Popover>
        <input
          id='inpUpRight'
          type='file'
          name='upperRightBanner'
          onChange={e => handleChange(e, 6)}
        />
      </div>
      <div className={lowerRightContainer}>
        <span>Banner lateral inferior <br/> (236 x 514)</span>
        <Popover
          title={countFiles('lowerRightBanner', 6)}
          content={content('lowerRightBanner')}
        >
          <label htmlFor='inpLowRight'>Examinar...</label>
        </Popover>
        <input
          id='inpLowRight'
          type='file'
          name='lowerRightBanner'
          onChange={e => handleChange(e, 6)}
        />
      </div>
      <div className={fixedLeftContainer}>
        <span>Banner inferior izquierdo <br/> (244 x 434)</span>
        <Popover
          title={countFiles('fixedLeft', 1)}
          content={content('fixedLeft')}
        >
          <label htmlFor='inpFixLeft'>Examinar...</label>
        </Popover>
        <input
          id='inpFixLeft'
          type='file'
          name='fixedLeft'
          onChange={e => handleChange(e, 1)}
        />
      </div>
    </div>
  );
};

export default IntermediateStand;